import { useParams, useLocation } from 'react-router-dom';
import { getDashboardAppRoutePrefix } from 'FormsUI/lib/RouteGenerators';
import { DEFAULT_VIEW_IDS } from 'FormsUI/components/dashboard/frameworkTable/constants';
/**
 * Redirects to the new dashboard app (any dashboard page, analyze, comparison tool, type, templates, etc)
 * Handles redirects for:
 * - / (main dashboard)
 * - /views/:viewId
 * - /folders
 * - /manage
 * - /analyze
 * - /templates
 * - /type
 * - /type-experiment
 * - /compare
 */
const RedirectToDashboard = ({
  path
}) => {
  const {
    viewId
  } = useParams();
  const location = useLocation();

  // Determine the redirect path
  let redirectPath = '';
  if (path) {
    redirectPath = path.startsWith('/') ? path : `/${path}`;
    redirectPath = redirectPath.replace(':viewId', viewId || DEFAULT_VIEW_IDS.ALL_FORMS);
  }
  const dashboardUrl = getDashboardAppRoutePrefix({
    path: redirectPath,
    search: location.search
  });
  window.location.replace(dashboardUrl);
  return null;
};
export default RedirectToDashboard;